export default [
    {
        path: '/admin/allowance-items',
        name: 'item-allowances',
        meta: { requiresAuth: true },
        component: () => import('@/pages/payroll/item-allowance/index.vue')
    },
]
